import { render, staticRenderFns } from "./NewsAndGuidesArticle.vue?vue&type=template&id=7ede3e1c&scoped=true"
import script from "./NewsAndGuidesArticle.vue?vue&type=script&lang=js"
export * from "./NewsAndGuidesArticle.vue?vue&type=script&lang=js"
import style0 from "./NewsAndGuidesArticle.vue?vue&type=style&index=0&id=7ede3e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ede3e1c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PrismicSlice: require('/home/runner/work/marketing/marketing/components/PrismicSlice.vue').default,ArticleCard: require('/home/runner/work/marketing/marketing/components/ArticleCard.vue').default,Carousel: require('/home/runner/work/marketing/marketing/components/Carousel.vue').default})
